module.exports = __webpack_public_path__ + "media/goodBeer.390988b9.mp3";